import { FunctionComponent, useEffect, useRef, useState } from "react";
import "./SubtopicMobile.scss";
import Table from "../../Components/Table/Table";
import CustomToolbar from "../../Components/Table/components/CustomToolbar";
import ButtonField from "../../Components/Button/ButtonField";
import { Columns } from "../../Components/Table/ITable";
import {
  GridRenderCellParams,
  GridValueFormatterParams,
} from "@mui/x-data-grid";
import { ISubtopicMobile } from "./ISubtopicMobile";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import Dialog from "../../Components/Dialog/Dialog";
import SubtopicMobileForm from "./SubtopicMobileForm";
import ResponseDialog from "../../Components/ResponseDialog/ResponseDialog";
import TableSearch from "../../Components/Table/components/TableSearch";
import { ReactComponent as Delete } from "../../Assets/Images/delete.svg";
import { ReactComponent as Edit } from "../../Assets/Images/edit.svg";
import { IDeleteDialog } from "../../Components/DeleteDialog/IDeleteDialog";
import IconButtonField from "../../Components/Button/IconButtonField";
import { SvgIcon } from "@mui/material";
import DeleteDialog from "../../Components/DeleteDialog/DeleteDialog";
import { ReactComponent as RefreshButton } from "../../Assets/Images/RefreshButton.svg";
import { listSubtopicMobile } from "../../Redux/Slices/SubtopicMobile/ListSubtopicMobileSlice";
import { clearAddSubtopicMobileResponse } from "../../Redux/Slices/SubtopicMobile/AddSubtopicMobileSlice";
import {
  clearDeleteSubtopicMobileResponse,
  deleteSubtopicMobile,
} from "../../Redux/Slices/SubtopicMobile/DeleteSubtopicMobileSlice";
import { clearEditSubtopicMobileResponse } from "../../Redux/Slices/SubtopicMobile/EditSubtopicMobileSlice";
import { listSideMenuPermission } from "../../Redux/Slices/SideMenuPermission/ListSideMenuPermissionSlice";
import { listSubjectMobile } from "../../Redux/Slices/SubjectMobile/ListSubjectMobileSlice";
import { listyearGroup } from "../../Redux/Slices/yearGroup/ListyearGroupSlice";

interface SubtopicMobileProps {}

const SubtopicMobile: FunctionComponent<SubtopicMobileProps> = () => {
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState<boolean>(false);
  const [deleteDialogData, setDeleteData] = useState<IDeleteDialog>({});
  const [initialValues, setInitialValues] = useState<ISubtopicMobile | {}>({
    status: true,
  });
  const dispatch = useAppDispatch();
  const { data: listSubtopicMobiles } = useAppSelector(
    (state) => state.ListSubtopicMobileSlice
  );
  const { data: addSubtopicMobile } = useAppSelector(
    (state) => state.AddSubtopicMobileSlice
  );
  const { data: EditSubtopicMobile } = useAppSelector(
    (state) => state.EditSubtopicMobileSlice
  );
  const { data: deleteSubtopicMobiles } = useAppSelector(
    (state) => state.DeleteSubtopicMobile
  );

  // user permisssion
  const { data: userPermissionlist } = useAppSelector(
    (state) => state.SideMenuPermission
  );

  const to = "settings";

  const filteredList = userPermissionlist.Dashboard.filter(
    (item: any) => item.to === to
  );
  const fliterdata: any = filteredList[0]?.items;
  const finaldata = fliterdata[0];

  const formRef = useRef<HTMLFormElement>(null);
  const columns: Columns = [
    {
      field: "index",
      renderHeader: () => <b>S.No</b>,
      width: 90,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "name",
      renderHeader: () => <b>Sub Topic</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
    },
    {
      field: "year_level",
      renderHeader: () => <b>Year Group</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
    },
    {
      field: "sequence",
      renderHeader: () => <b>Sequence</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
    },
    {
      field: "status",
      renderHeader: () => <b>Status</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
      cellClassName: (params) =>
        `activename ${params.row.status ? "active" : "inactive"}`,

      valueFormatter: (params) =>
        params.value === true ? "Active" : "Inactive",
    },
    {
      field: "action",
      renderHeader: () => <b>Action</b>,
      flex: 1,
      type: "actions",
      renderCell: (params: GridRenderCellParams<ISubtopicMobile>) => {
        return (
          <>
            <IconButtonField
              disabled={finaldata?.permissions?.edit === false}
              onClick={() => {
                setInitialValues({ ...params.row });
                setDialogOpen(true);
              }}
            >
              <SvgIcon sx={{ fill: "none" }} component={Edit} inheritViewBox />
            </IconButtonField>
            <IconButtonField
              disabled={finaldata?.permissions?.delete === false}
              onClick={() => {
                setDeleteData({ id: params.id, name: params?.row?.name });
                setDeleteDialogOpen(true);
              }}
            >
              <SvgIcon component={Delete} inheritViewBox />
            </IconButtonField>
          </>
        );
      },
    },
  ];

  const SubtopicMobile = Array.isArray(listSubtopicMobiles?.data)
    ? listSubtopicMobiles?.data.map((user, index) => ({
        ...user,
        index: index + 1,
      }))
    : [];

  useEffect(() => {
    dispatch(listSubtopicMobile());
    dispatch(listSubjectMobile());
    dispatch(listyearGroup());
    // dispatch(listSideMenuPermission());
  }, [addSubtopicMobile, EditSubtopicMobile, deleteSubtopicMobiles, dispatch]);
  useEffect(() => {
    return () => {
      dispatch(clearAddSubtopicMobileResponse());
      dispatch(clearEditSubtopicMobileResponse());
      dispatch(clearDeleteSubtopicMobileResponse());
    };
  }, [dispatch]);
  return (
    <>
      <Table rows={SubtopicMobile ?? []} columns={columns}>
        <CustomToolbar>
          <h6>Sub Topic</h6>
          <TableSearch />
          <ButtonField
            className="tabel_add_new_button"
            onClick={() => setDialogOpen(true)}
            toolTip="Add new"
            disabled={finaldata?.permissions?.add === false}
          >
            Add new
          </ButtonField>
          <IconButtonField
            className="refresh_btn"
            toolTip="Refresh"
            onClick={() => dispatch(listSubtopicMobile())}
          >
            <SvgIcon
              className="refresh_svg_icon"
              component={RefreshButton}
              inheritViewBox
            />
          </IconButtonField>
        </CustomToolbar>
      </Table>

      <Dialog
        open={dialogOpen}
        dialogClassName="dialog_double_input"
        Dialog_Title={`${
          (initialValues as ISubtopicMobile).id ? "Update" : "Add"
        } Sub Topic`}
        Dialog_Content={
          <SubtopicMobileForm
            formRef={formRef}
            initialValues={initialValues}
            setInitialValues={setInitialValues}
          />
        }
        Dialog_Actions={
          <>
            <ButtonField
              className="form_cancel_button"
              onClick={() => setDialogOpen(false)}
            >
              Cancel
            </ButtonField>
            <ButtonField
              className="form_save_button"
              onClick={() => formRef.current?.requestSubmit()}
            >
              Save
            </ButtonField>
          </>
        }
      />
      <ResponseDialog
        response={addSubtopicMobile}
        parentDialog={setDialogOpen}
      />
      <ResponseDialog
        response={EditSubtopicMobile}
        parentDialog={setDialogOpen}
      />
      <DeleteDialog
        deleteableName={deleteDialogData.name ?? ""}
        open={deleteDialogOpen}
        setOpen={setDeleteDialogOpen}
        deleteFunction={() => {
          dispatch(deleteSubtopicMobile(deleteDialogData.id));
        }}
        response={deleteSubtopicMobiles}
      />
    </>
  );
};

export default SubtopicMobile;
